import React from 'react';
import 'react-h5-audio-player/lib/styles.css';
import SGCommonPage from '../../../components/SGCommonPage';


function SavaiyeM1() {
    return (
        <div>
            <SGCommonPage title="Savaiye M:1" apiName="savaiye-m1" audioName="savaiye_m1" tlPage="3" /> 
        </div>
    )
}

export default SavaiyeM1